import DisplayOnlyValue from "./DisplayOnlyValue";
export default DisplayOnlyValue;
